import {
  Button,
  ButtonsWrapper,
  Form,
  Modal,
  SelectInput,
} from '@thinknet-gmbh/platform-common-ui';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { EmployeeCreationTypeEnum } from '@thinknet-gmbh/platform-common';
import { ROUTES } from 'src/components/app/app-routes.constants';
import { EMPLOYEE_PAGES } from 'src/pages/employee/employee.constants';
import { useNavigate } from 'react-router-dom';

interface IProps {
  isOpened: boolean;
  onClose: () => void;
  applicantId: string;
  openQuestionnaireModal: () => void;
}

const TakeApplicantAsEmployeeSelectModal: FC<IProps> = ({
  isOpened,
  onClose,
  applicantId,
  openQuestionnaireModal,
}) => {
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();

  const onFinish = ({ creationBy }: { creationBy: string }) => {
    if (creationBy === EmployeeCreationTypeEnum.manually) {
      navigate(`${ROUTES.employee}/${EMPLOYEE_PAGES.createEmployee}?applicantId=${applicantId}`);
    }
    if (creationBy === EmployeeCreationTypeEnum.questionnaire) {
      openQuestionnaireModal();
    }
  };

  return (
    <Modal
      isOpened={isOpened}
      onClose={onClose}
      title={t('vacancies:buttons.takeApplicantAsEmployee')}
    >
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="creationBy"
          label={t('employee:questionnaire.labels.creationType')}
          rules={[{ required: true, message: t('common:validation.error.fieldRequired') }]}
        >
          <SelectInput placeholder={t('common:placeholders.selectFromList')}>
            <SelectInput.Option value={EmployeeCreationTypeEnum.questionnaire}>
              {t('employee:labels.byQuestionnaire')}
            </SelectInput.Option>
            <SelectInput.Option value={EmployeeCreationTypeEnum.manually}>
              {t('employee:labels.manually')}
            </SelectInput.Option>
          </SelectInput>
        </Form.Item>

        <ButtonsWrapper marginTop={16}>
          <Button type="primary" htmlType="submit">
            {t('common:buttons.create')}
          </Button>
          <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </Modal>
  );
};

export default TakeApplicantAsEmployeeSelectModal;
